import React from 'react';
import PropTypes from 'prop-types';

import { StyledField } from './StyledField';
import { FieldProps } from './types';

export const Field = ({ children }: FieldProps) => {
  return <StyledField>{children}</StyledField>;
};

Field.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  focus: PropTypes.bool,
};
